"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H4 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H4",
  componentId: "omkcxh-0"
})(_templateObject());
H4.propTypes = _Heading.default.propTypes;
H4.defaultProps = (0, _extends2.default)({}, _Heading.default.defaultProps, {
  tagName: 'h4'
});
H4.displayName = 'H4';
var _default = H4;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/elements/headings/H4.js
// module id = 80
// module chunks = 209 210 211 212